import React from 'react'
import { selectFamilyForNewTeacherEvent } from '../../../../Calendar/calendarFunctions'
import './teacher-calendar-family-search.css'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const TeacherCalendarFamilySearch = ({teachersFamilies, setEvent, setStep, loading}) => {
    const [selected, setSelected] = React.useState(false)

    const nextStep = () => {
        let fam = teachersFamilies.filter((family) => family.familyId === selected.familyId)
        let student = fam[0].students.filter((student) => student.studentId === selected.studentId)
        selectFamilyForNewTeacherEvent(fam[0], student[0], setEvent)
        setStep(2)
    }
    return (
        <div className='teacher-calendar-family-search__wrapper'>
            <div className='teacher-calendar-family-search__modal'>
              {loading ? 
                <div>creating events...</div>
                :
                <div>
                  <Listbox value={selected} onChange={setSelected}>
                    {({ open }) => (
                      <>
                        <div className='teacher-calendar-family-search__title'>Select Student for Lesson:</div>
                        <div className='teacher-calendar-family-search__sub-title'>Which student do you want to make an event for?</div>
                        <Listbox.Label className="block text-xs font-bold text-left text-gray-700">Student*</Listbox.Label>
                        <div className="relative mt-1">
                          <Listbox.Button className="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm">
                            <span className="block truncate">{selected.displayName}</span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                          </Listbox.Button>
                          <Transition show={open} as={React.Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
                            <Listbox.Options className="absolute z-10 mt-1 -ml-4 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                              {teachersFamilies.map((family) => (
                                  family.students.map((student) => (
                                    <Listbox.Option value={{familyId: family.familyId, studentId: student.studentId, displayName: `${student.studentName} ${family.familyName}`}} key={student.studentId} className={({ active }) => classNames( active ? 'text-white bg-indigo-600' : 'text-gray-900', 'relative cursor-default select-none py-2 pl-3 pr-9')}>
                                      {({ selected, active }) => (
                                        <>
                                          <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                            {`${student.studentName} ${family.familyName}`} 
                                          </span>
                                          {selected ? (<span className={classNames( active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4')}><CheckIcon className="h-5 w-5" aria-hidden="true" /></span>) : null}
                                        </>
                                      )}
                                    </Listbox.Option>
                                  ))
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                  <div className='teacher-calendar-family-search__btn-wrapper'>
                      <div className='teacher-calendar-family-search__btn' onClick={() => setEvent(false)}>Back</div>
                      <div className='teacher-calendar-family-search__btn teacher-calendar-next-btn' onClick={() => nextStep()}>Next</div>
                  </div>
                </div>
              }
            </div>
        </div>
    )
}
export default TeacherCalendarFamilySearch